<template>
  <div class="main-data" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form ref="form" :model="form" :rules="rules" label-position="top">
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item
                  label="Berilgan vazifasi"
                  prop="role"
              >
                <el-select style="width: 100%" size="large" v-model="form.role">
                  <el-option
                      v-for="role in roles"
                      :key="role.id"
                      :value="role.id"
                      :label="role.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Viloyat" prop="region_id">
                <el-select
                    style="width: 100%"
                    size="large"
                    v-model="form.region_id"
                    @change="getDistricts"
                    :loading="regionsLoading"
                >
                  <el-option
                      v-for="region in regions"
                      :key="region.id"
                      :value="region.id"
                      :label="region.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Tuman" prop="district_id">
                <el-select
                    style="width: 100%"
                    size="large"
                    @change="onChangeDistrict"
                    v-model="form.district_id"
                    :loading="districtsLoading"
                >
                  <el-option
                      v-for="district in districts"
                      :key="district.id"
                      :value="district.id"
                      :label="district.title"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col v-if="form.role==='quarter_manager'||form.role==='quarter_moderator'" :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Mahallani tanlang" prop="quarter_id">
                <el-select
                    style="width: 100%"
                    v-loading="quarterLoading"
                    v-model="form.quarter_id"
                    size="large"
                    placeholder="Mahallani tanlang"
                >
                  <el-option
                      v-for="quarter in quarters"
                      :value="quarter.id"
                      :label="quarter.title"
                      :key="quarter.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Ismi Sharifi" prop="fullname">
                <el-input
                    size="large"
                    class="form-input"
                    v-model="form.fullname"
                    type="text"
                />
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Pinfl" prop="pinfl">
                <el-input
                    size="large"
                    class="form-input"
                    v-model="form.pinfl"
                    type="number"
                />
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Holat" v-if="is_editing">
                <el-select
                  style="width: 100%"
                  size="large"
                  v-model="form.status"
                  @change="onStatusChange"
                >
                  <el-option label="Faol"   :value="1" />
                  <el-option label="Nofaol" :value="2" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="showStatusReason">
              <el-form-item label="Sabab (ixtiyoriy)">
                <el-input type="textarea" :rows="2" v-model="form.status_reason" />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="() => this.$router.go(-1)">Orqaga</el-button>
                <el-button class="custom-btn" type="primary" @click="onSubmit">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import {ElMessage, ElNotification, ElMessageBox} from "element-plus";
import http from "@/http";

export default {
  name: "RegionModeratorForm",
  data() {
    return {
      loading: false,
      is_editing: false,
      originalStatus: null,
      showStatusReason: false,
      regionsLoading: false,
      districtsLoading: false,
      roles: [
        {title: "Viloyat boshqaruvi", id: "region_manager"},
        {title: "Tuman boshqaruvi", id: "district_manager"},
        {title: "Mahalla boshqaruvi", id: "quarter_manager"},
        {title: "Mahalla moderatori", id: "quarter_moderator"}
      ],
      regions: [],
      districts: [],
      form: {
        id: null,
        fullname: null,
        role: "region_manager",
        district_id: null,
        region_id: null,
        pinfl: null,
        quarter_id: null,
      status: null,
      status_reason: null,
      },
      quarterLoading: false,
      quarters: [],
      rules: {
        fullname: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
        region_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        district_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        quarter_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        pinfl: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
      },
    };
  },
  methods: {
    statusLabel(status) {
      const map = { 1: "Faol", 2: "Nofaol", 3: "Bloklangan", 4: "Jarayonda" };
      return map[status] || "-";
    },
    statusTagType(status) {
      const map = { 1: "success", 2: "danger", 3: "danger", 4: "warning" };
      return map[status] || "info";
    },
    onStatusChange(val) {
      this.showStatusReason = val !== this.originalStatus;
    },
    onChangeDistrict() {
      this.getQuarters();
    },
    getQuarters() {
      this.quarterLoading = true;
      http({url: `/api/v1/quarters?district_id=${this.form.district_id}`})
          .then(({data}) => {
            this.quarters = data.quarters;
          })
          .catch(() => {
            ElMessage.error(`Mahalla yuklanmadi. Qayta urinib ko'ring`);
          })
          .finally(() => {
            this.quarterLoading = false;
          });
    },
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (
            this.form.id &&
            this.originalStatus === 1 &&
            this.form.status !== this.originalStatus
          ) {
            try {
              await ElMessageBox.confirm(
                "Foydalanuvchi holatini o'zgartirish uni tizimdan chiqaradi. Davom etasizmi?",
                "Diqqat!",
                { confirmButtonText: "Ha", cancelButtonText: "Bekor qilish", type: "warning" }
              );
            } catch {
              return;
            }
          }

          this.loading = true;

          let http;

          const formData = {
            ...this.form,
          };

          if (this.form.id) {
            http = this.$http.put(`/api/v1/managers/${this.form.id}`, formData);
          } else {
            http = this.$http.post("/api/v1/managers", formData);
          }

          http
              .then(() => {
                ElNotification({
                  title: "Tabriklaymiz",
                  message: "Muvafaqiyatli saqlandi",
                  type: "success",
                });
                this.$router.go(-1);
              })
              .catch(({response}) => {
                ElNotification({
                  title: "Xatolik",
                  message:
                      response.data.message || "Iltimos, qayta urinib ko'ring.",
                  type: "error",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
    getRegions() {
      this.regionsLoading = true;
      this.$http
          .get("/api/v1/regions")
          .then(({data}) => {
            this.regions = data.regions;
          })
          .catch(() => {
          })
          .finally(() => {
            this.regionsLoading = false;
          });
    },
    getDistricts() {
      this.districtsLoading = true;
      this.$http
          .get("/api/v1/districts", {
            params: {
              region_id: this.form.region_id,
            },
          })
          .then(({data}) => {
            this.districts = data.districts;
          })
          .catch(() => {
          })
          .finally(() => {
            this.districtsLoading = false;
          });
    },
    getModerator(id) {
      this.loading = true;
      this.$http
          .get(`/api/v1/managers/${id}`)
          .then(({data}) => {
            this.form = data;
            this.originalStatus = data.status;
            this.getDistrict(this.form.district_id);
            this.getQuarters(this.form.district_id)
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getDistrict(id) {
      this.loading = true;
      this.$http
          .get(`/api/v1/districts/${id}`)
          .then(({data}) => {
            this.districts.push(data);
            this.form.region_id = data.region_id;
            this.getDistricts();
          })
          .catch(({response}) => {
            ElNotification({
              type: "error",
              title: "Xatolik",
              message: response.data.message || "Yuklashda xatolik sodir bo'ldi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.is_editing = true;
      this.getModerator(this.$route.params.id);
    }
    this.getRegions();
  },
};
</script>

<style scoped></style>
